module.exports = __webpack_public_path__ + "img/icon_youtube.52e2e8b1.svg";